import { HTTP } from '../../http';

const state = {
  countries: {},
  platesSelectList: [],
  batteriesTypes: [],
  batteryDiagnosis: [],
  minTemp: null,
  maxTemp: null,
  minVolt: null,
  maxVolt: null
};

const mutations = {
  setCountries(state, countries) {
    state.countries = countries;
  },
  setMinTemp(state, temp) {
    state.minTemp = temp;
  },
  setMaxTemp(state, temp) {
    state.maxTemp = temp;
  },
  setMinVolt(state, temp) {
    state.minVolt = temp;
  },
  setMaxVolt(state, temp) {
    state.maxVolt = temp;
  },
  setPlatesSystemList(state, platesSelectList) {
    state.platesSelectList = platesSelectList;
  },
  setBatteriesTypes(state, batteriesTypes) {
    state.batteriesTypes = batteriesTypes;
  },
  setBatteryDiagnosis(state, batteryDiagnosis) {
    state.batteryDiagnosis = batteryDiagnosis;
  }
};

const getters = {
  getConfig: state => state,
  getCountries: state => state.countries,
  getPlatesSelectList: state => state.platesSelectList,
  getBatteriesTypes: state => state.batteriesTypes,
  getBatteryDiagnosis: state => state.batteryDiagnosis
};

const actions = {
  getConfigFromBackend: ({ commit }) => {
    let countries = {};
    let platesSelectList = [];
    HTTP.get('api/app/config')
      .then(response => {
        countries = response.data.countries;
        platesSelectList = response.data.platesSelectList;
        commit('setCountries', countries);
        commit('setPlatesSystemList', platesSelectList);
        commit('setBatteriesTypes', response.data.batteriesTypes);
        commit('setBatteryDiagnosis', response.data.batteryDiagnosis);
        commit('setMaxVolt', response.data.voltageMax);
        commit('setMinVolt', response.data.voltageMin);
        commit('setMinTemp', response.data.temperatureMin);
        commit('setMaxTemp', response.data.temperatureMax);
      })
      .catch(() => {});
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
